/** Caricamento lazy di librerie pesanti (export PDF/Excel, manuale markdown). */

const scriptCache = new Map();

function loadScript(src) {
  if (scriptCache.has(src)) return scriptCache.get(src);
  const p = new Promise((resolve, reject) => {
    const el = document.createElement('script');
    el.src = src;
    el.async = true;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error(`Script non caricato: ${src}`));
    document.head.appendChild(el);
  });
  scriptCache.set(src, p);
  return p;
}

export async function ensureMarked() {
  if (window.marked) return window.marked;
  await loadScript('https://cdn.jsdelivr.net/npm/marked/marked.min.js');
  return window.marked;
}

export async function ensureXlsx() {
  if (window.XLSX) return window.XLSX;
  await loadScript('https://cdn.sheetjs.com/xlsx-0.20.1/package/dist/xlsx.full.min.js');
  return window.XLSX;
}

export async function ensurePdfLib() {
  if (window.PDFLib) return window.PDFLib;
  await loadScript('https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js');
  return window.PDFLib;
}

export async function ensureHtml2canvas() {
  if (window.html2canvas) return window.html2canvas;
  await loadScript('https://unpkg.com/html2canvas@1.4.1/dist/html2canvas.min.js');
  return window.html2canvas;
}
